import React, { useEffect, useState } from "react";
import { getDataAxios } from "../../utils/Utils";
import ButtonRequire from "../../components/Button/ButtonRequire";
import _ from "lodash";

export default function BankDetailsFragment({
  dataUser,
  dataOutlet,
  setFragment,
}) {
  const [inputBank, setInputBank] = useState({});
  useEffect(() => {
    GetData();
    return () => {
      setInputBank({});
    };
  }, []);

  async function GetData(isReturn) {
    try {
      // Get data bank details
      let bank = await getDataAxios(
        `${process.env.REACT_APP_BASE_URL_API}/bankAccount?channel_id=${dataOutlet.channel_id}`,
      );
      if (bank.data.data[0]) {
        bank = bank.data.data[0];
      }

      // get data channel details for get ewallet status
      let channel = await getDataAxios(
        `${process.env.REACT_APP_BASE_URL_API}/channel/${dataOutlet.channel_id}`,
      );
      channel = channel.data.data;

      if (isReturn) {
        return bank;
      } else {
        setInputBank((prevState) => ({
          ...prevState,
          bank_account_id: bank.bank_account_id,
          bank_name: bank.bank_name,
          bank_number: bank.bank_number,
          holder_name: bank.holder_name,
          ewallet_status: channel.ewallet_status,
          channel_sub_sub_category: channel.channel_sub_sub_category,
          kartini_channel_id: channel.kartini_channel_id,
        }));
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function SaveOrEditBankDetail() {
    if (inputBank.ewallet_status === "active") {
      //  await axios
      //     .put(
      //        `${process.env.REACT_APP_BASE_URL_API}/channel/${dataOutlet.channel_id}`,
      //        {
      //           ewallet_status: inputBank.ewallet_status,
      //           channel_sub_sub_category: inputBank.channel_sub_sub_category,
      //           kartini_channel_id: inputBank.kartini_channel_id,
      //        },
      //        { headers: HEADER }
      //     )
      //     .then((res) => {
      //        logger("PUT /channel => ", res.data.data);
      //     })
      //     .catch((error) => console.error(error));
      //  if (inputBank.bank_account_id) {
      //     await axios
      //        .put(
      //           `${process.env.REACT_APP_BASE_URL_API}/bankAccount/${inputBank.bank_account_id}`,
      //           {
      //              ...inputBank,
      //              outlet_kartini_id: dataOutlet.outlet_kartini_id,
      //           },
      //           { headers: HEADER }
      //        )
      //        .then((res) => {
      //           // set fragment
      //           setFragment("pin-setup");
      //        })
      //        .catch((error) => console.error(error));
      //  } else {
      //     await axios
      //        .post(
      //           `${process.env.REACT_APP_BASE_URL_API}/bankAccount`,
      //           {
      //              ...inputBank,
      //              outlet_kartini_id: dataOutlet.outlet_kartini_id,
      //           },
      //           { headers: HEADER }
      //        )
      //        .then((res) => {
      //           // set fragment
      //           setFragment("pin-setup");
      //        })
      //        .catch((error) => console.error(error));
      //  }
      setFragment("pin-setup");
    } else {
      setFragment("policy-agreement");
    }
  }
  return (
    <div className="space-y-3">
      <h2 className="font-medium text-gray-700">Bank Details</h2>
      <form className="mt-4 space-y-3">
        <div className="flex items-center space-x-2">
          <label className="mb-1 whitespace-nowrap text-sm font-medium">
            E-Wallet <span className="text-rose-500">*</span>
          </label>
          <select
            id="country"
            className="form-select h-12 w-full"
            value={inputBank.ewallet_status}
            onChange={(e) =>
              setInputBank((prevState) => ({
                ...prevState,
                ewallet_status: e.target.value,
              }))
            }
            placeholder="Select"
            disabled
          >
            <option value="">Select</option>
            <option value="active">YES</option>
            <option value="inactive">NO</option>
          </select>
        </div>
        <input
          name="bank_name"
          placeholder="Nama Bank"
          className="form-input h-12 w-full disabled:bg-gray-100"
          value={inputBank.bank_name}
          onChange={(e) =>
            setInputBank((prevState) => ({
              ...prevState,
              [e.target.name]: e.target.value,
            }))
          }
          // disabled={inputBank.ewallet_status === "active" ? false : true}
          disabled
        />
        <input
          name="holder_name"
          placeholder="Nama Pemilik Rekening"
          className="form-input h-12 w-full disabled:bg-gray-100"
          value={inputBank.holder_name}
          onChange={(e) =>
            setInputBank((prevState) => ({
              ...prevState,
              [e.target.name]: e.target.value,
            }))
          }
          // disabled={inputBank.ewallet_status === "active" ? false : true}
          disabled
        />
        <input
          name="bank_number"
          placeholder="Nomor Rekening"
          className="form-input h-12 w-full disabled:bg-gray-100"
          value={inputBank.bank_number}
          onChange={(e) =>
            setInputBank((prevState) => ({
              ...prevState,
              [e.target.name]: e.target.value,
            }))
          }
          // disabled={inputBank.ewallet_status === "active" ? false : true}
          disabled
        />
      </form>
      <ButtonRequire
        title={
          inputBank.ewallet_status === "active"
            ? "Check Bank Details"
            : "Continue"
        }
        functionOnClick={SaveOrEditBankDetail}
        isDisabled={_.isEmpty(inputBank.ewallet_status)}
      />
    </div>
  );
}
